<template>
  <DialogModal :is-destructive-alert="false" :hideSecondaryButton="true" @primary="$emit('ok')">
    <span slot="header" v-localize="HEADER_TEXT_KEY" />
    <span slot="body" v-localize="BODY_TEXT_KEY" />
    <span slot="primary-button-text" v-localize="PRIMARY_BUTTON_TEXT_KEY" />
  </DialogModal>
</template>

<script>
import DialogModal from '@/components/AvatarBuilderUI/Dialogs/DialogModal.vue';
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'ItemUnavailableDialog',
  components: {
    DialogModal,
  },
  created: function() {
    this.HEADER_TEXT_KEY = 'ItemUnavailableDialogTitle';
    this.BODY_TEXT_KEY = 'ItemUnavailableDialogMessage';
    this.PRIMARY_BUTTON_TEXT_KEY = 'OK';
  },
  directives: {
    LocalizationDirective,
  },
};
</script>
